<section class="icip-enterprise" id="testimonials" aria-label="Testimonials">
  <div class="icip-enterprise__container">
    <div class="icip-enterprise__header icip-reveal" appInView>
      <div class="icip-enterprise__kicker">Testimonials</div>
      <h2 class="icip-enterprise__title">Trusted by Carriers &amp; Enterprises Worldwide</h2>
      <p class="icip-enterprise__subtitle">
        Operators and enterprise brands across Europe rely on ICIP to deliver verified, branded calling at scale — with the governance controls to match.
      </p>
    </div>

    <div class="icip-enterprise__marquee" #marquee>
      <div class="icip-enterprise__fade icip-enterprise__fade--left" aria-hidden="true"></div>
      <div class="icip-enterprise__fade icip-enterprise__fade--right" aria-hidden="true"></div>

      <div class="icip-enterprise__track" #track>
        <div class="icip-enterprise__row" #row>
          <div class="icip-enterprise__card" *ngFor="let t of items; trackBy: trackByIndex">
            <p class="icip-enterprise__quote">"{{ t.quote }}"</p>
            <div class="icip-enterprise__author">
              <img class="icip-enterprise__avatar" [src]="t.avatar" [alt]="t.name" loading="lazy" />
              <div>
                <div class="icip-enterprise__name">{{ t.name }}</div>
                <div class="icip-enterprise__role">{{ t.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
